import { checkUrl, getUrlDisplayPart } from '@djs';
import { PairTagChildrenParser } from './getWikiSyntaxTree';

export const linkChildrenParser: PairTagChildrenParser = (children, processHref, additionalLinkParser) => {
  const pairs = children.length === 1 && typeof children[0] === 'string' ? children[0].split('|') : [];

  if (pairs.length !== 1 && pairs.length !== 2) {
    return { process: false };
  }

  const result = checkUrl(pairs[0]);

  if (!result.valid) {
    const parserResult = additionalLinkParser?.(pairs);

    return parserResult || { process: false };
  }

  return {
    process: true,
    attributes: { href: processHref(result.href), target: '_blank', rel: 'noreferrer noopener' },
    children: [pairs[1] ?? getUrlDisplayPart(pairs[0])],
  };
};
